import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Avatar from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Avatar';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[23],
    width: theme.spacing(8),
    height: theme.spacing(8),
  },
  icon: {
    height: '50%',
    width: '50%',
  },
});

const HeaderAvatarIcon = ({
  className,
  classes,
  icon,
}) => {
  return (
    <Avatar
      className={classNames(classes.root, className)}
    >
      <Icon
        className={classes.icon}
        icon={icon}
      />
    </Avatar>
  );
};

HeaderAvatarIcon.defaultProps = {
  className: '',
};

HeaderAvatarIcon.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default withStyles(styles)(HeaderAvatarIcon);
